import { render, staticRenderFns } from "./TagsHome.vue?vue&type=template&id=2ac0db12"
import script from "./TagsHome.vue?vue&type=script&lang=js"
export * from "./TagsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac0db12')) {
      api.createRecord('2ac0db12', component.options)
    } else {
      api.reload('2ac0db12', component.options)
    }
    module.hot.accept("./TagsHome.vue?vue&type=template&id=2ac0db12", function () {
      api.rerender('2ac0db12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/entityTags/TagsHome.vue"
export default component.exports